import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from './store';
import { USER_DATA } from './store/features/authSlice';
import { CookiesProvider } from 'react-cookie';

const root = ReactDOM.createRoot(document.getElementById('root'));
const fetchData = async () => {
  store.dispatch(USER_DATA({ payload: { IS_LOGGED: true } }))
};
fetchData();
root.render(
  <CookiesProvider>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </CookiesProvider>
);

reportWebVitals();
